<template>
  <div>
    <div class="page-container">
      <div class="page-title"><img src="~@/assets/image/icons/book.png" alt="">{{$t('upgrade_page_views_withdraw_withdrawguide_2397')}}</div>
      <div class="page-content">
        <div>
          <div class="page-left">1</div>
          <div class="page-right">
            <p>{{$t('upgrade_page_views_withdraw_withdrawguide_2398')}}<span @click="jumpWithdraw">{{$t('upgrade_page_views_withdraw_withdrawguide_2399')}}</span>{{$t('upgrade_page_views_withdraw_withdrawguide_2400')}}</p>
          </div>
        </div>
        <div>
          <div class="page-left">2</div>
          <div class="page-right">
            <p>{{$t('upgrade_page_views_withdraw_withdrawguide_2401')}}<a href="https://www.newebpay.com/">{{$t('upgrade_page_views_withdraw_index_1555')}}</a>{{$t('upgrade_page_views_withdraw_withdrawguide_2402')}}</p>
            <p>{{$t('upgrade_page_views_withdraw_withdrawguide_2403')}}</p>
            <h3>{{$t('upgrade_page_views_withdraw_withdrawguide_2404')}}</h3>
            <div class="houseofhello"></div>
          </div>
        </div>
        <div>
          <div class="page-left">3</div>
          <div class="page-right">
            <p>{{$t('upgrade_page_views_withdraw_withdrawguide_2405')}}</p>
            <h3>{{$t('upgrade_page_views_withdraw_withdrawguide_2406')}}</h3>
            <div class="atm-step-1">
              <img src="~@/assets/image/background/atm-step-2.png" alt="">
            </div>
          </div>
        </div>
        <div>
          <div class="page-left">4</div>
          <div class="page-right">
            <p>{{$t('upgrade_page_views_withdraw_withdrawguide_2407')}}</p>
            <h3>{{$t('upgrade_page_views_withdraw_withdrawguide_2408')}}</h3>
            <h3>{{$t('upgrade_page_views_withdraw_withdrawguide_2409')}}</h3>
            <div class="atm-step-2">
              <img src="~@/assets/image/background/atm-step-3.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'withdrawGuide',
  methods:{
    jumpWithdraw(){
      this.$router.push('/withdraw')
    }
  }
}
</script>
<style lang="scss" scoped>
  .page-container {
    background: #fff;
    margin: 40px auto;
    padding-bottom: 80px;
    >div{
      padding-left: 40px;
    }
    .page-title {
      display: flex;
      align-items: center;
      border-bottom: 1px solid $color-button;
      height: 92px;
      img{
        width: 18px;
        height: 22px;
        margin-right: 7px;
      }
    }
    .page-content{
      >div{
        display: flex;
        margin-top: 56px;
      }
      >div:nth-of-type(1){
        margin-top: 36px;
      }
    }
  }
  .page-left{
      font-weight: 300;
      font-size: 40px;
      line-height: 40px;
      text-align: center;
      letter-spacing: -0.000319808px;
      color: #222C43;
    }
    .page-right{
      margin-left: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      p{
        font-size: 14px;
        line-height: 20px;
        color: #222C43;
        span,a{
          color: #4987F5;
          cursor: pointer;
        }
      }
      h3{
        font-size: 14px;
        line-height: 20px;
        color: #636D86;
        margin-top: 8px;
        font-weight: normal;
      }
    }
    .houseofhello{
      width: 367px;
      height: 216px;
      margin-top: 20px;
      background: url('~@/assets/image/background/atm-step-1.png') no-repeat center center / 100%;
    }
    .atm-step-1{
      width: 673px;
      height: 342px;
      img{
        width: 633px;
      }
      img:nth-of-type(1){
        height: 302px;
      }
      img:nth-of-type(2){
        height: 161px;
        margin-top: 12px;
      }
    }
    .atm-step-2{
      width: 530px;
      height: 403px;
      img{
        width: 490px;
        height: 363px;
      }
    }
    .atm-step-1,.atm-step-2{
      background: #F5F5F5;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
    }
</style>
